import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const PaymentTypeLedgerService = {
  // Get all payment type ledgers
  getList: async () => {
    try {
      const response = await instance.get("/payment-type-ledgers", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching payment type ledgers:", error);
      throw error;
    }
  },

  // Get a single payment type ledger by ID
  getById: async (id) => {
    try {
      const response = await instance.get(`/payment-type-ledgers/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching payment type ledger ${id}:`, error);
      throw error;
    }
  },

  // Create a new payment type ledger
  create: async (data) => {
    try {
      const response = await instance.post("/payment-type-ledgers", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating payment type ledger:", error);
      throw error;
    }
  },

  // Update an existing payment type ledger
  update: async (id, data) => {
    try {
      const response = await instance.put(`/payment-type-ledgers/${id}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating payment type ledger ${id}:`, error);
      throw error;
    }
  },

  // Delete a payment type ledger
  delete: async (id) => {
    try {
      const response = await instance.delete(`/payment-type-ledgers/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting payment type ledger ${id}:`, error);
      throw error;
    }
  },
};

export default PaymentTypeLedgerService;
